import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setRecipeIngredients,
  setRecipeOptions,
  setRecipeKeyword,
  resetRecipeOptions as resetRecipeOptionsAction,
  resetRecipes as resetRecipesAction,
} from "./../store/actions";
import type { TIngredient } from "./../store/types";
import { resetRecipe as resetRecipeSuggession } from "modules/Recipes/store/actions";
import { useCustomNavigate } from 'core/hooks/useCustomNavigate'
import { RouterName } from "core/router";

export const useRecipe = () => {
  const navigate = useCustomNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const recipes = useSelector((state: any) => state.Ingredients.recipes);
  const user = useSelector((state: any) => state.Auth.userInfo);
  const options = useMemo(() => (
    location.state || recipes.options[user?.id] || []
  ), [recipes.options, user, location.state])

  const setIngradients = (ingredients: TIngredient[]) => {
    dispatch(setRecipeIngredients(ingredients))
  }

  const setOptions = (options: string[]) => {
    dispatch(setRecipeOptions({
      user_id: user?.id,
      options,
    }))
  }

  const setKeyword = (keyword: string) => {
    dispatch(setRecipeKeyword(keyword))
  }

  const resetRecipes = () => {
    dispatch(resetRecipesAction())
  }

  const resetRecipeOptions = () => {
    dispatch(resetRecipeOptionsAction())
  }

  const goToRecipeSuggession = (options: string[], updateStore: boolean = true) => {
    dispatch(resetRecipeSuggession())
    if (updateStore) {
      setOptions(options)
    }
    navigate(RouterName.INGREDIENT_RECIPES, !updateStore ? {state: options} : {})
  }

  return {
    ingredients: recipes.ingredients,
    options,
    keyword: recipes.keyword,
    setIngradients,
    setOptions,
    setKeyword,
    resetRecipes,
    resetRecipeOptions,
    goToRecipeSuggession,
    isIgnoreIds: !!location.state,
  }
}
